export const organizationAccountTypeMap = {
  TRIAL: 'trial',
  TRAINING: 'training',
  SILVER: 'silver',
};

export const eventTypes: { [name: string]: string } = {
  NOTE: 'NOTE',
  OPEN_AND_NOTE: 'OPEN_AND_NOTE',
  CLOSE_AND_NOTE: 'CLOSE_AND_NOTE',
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

export const breakpoints: { [name: string]: number } = {
  xs: 480,
  small: 576,
  medium: 768,
  large: 992,
  tablet: 1100,
  xl: 1315,
  xxl: 1600,
  xxxl: 1750,
};

export const xxSmallPageLimit: number = 5;
export const xSmallPageLimit: number = 9;
export const smallPageLimit: number = 25;
export const mediumPageLimit: number = 50;
export const largePageLimit: number = 100;

// Constants for CSS in JS styles
export const categoryChipColor: string = '#4B6699';

// Times in ms
export const THIRTY_MINUTES: number = 30 * 60 * 1000;
export const ONE_WEEK: number = 7 * 24 * 60 * 60 * 1000;

export const NO_REACTOR_IN_LICENSE_COPY: string =
  'Your license does not include Reactor. Please contact support for access.';

export const TRANSACTION_TYPE: { [name: string]: string } = {
  SENT: 'sent',
  RECEIVED: 'received',
  WITHDRAWAL: 'withdrawal',
  DEPOSIT: 'deposit',
};

export const CUSTOM_CLUSTER_MAX_TRANSFERS_LIMIT = 3e5; // 300,000

export const ALERT_RULE_MODIFICATION_ERROR: string =
  'You do not have permission to modify your organization’s alert rules. ' +
  'Contact support@chainalysis.com to learn more.';

// This is not a normal dash. It renders differently than the hyphen '-' and should be used
// for consistency wherever an empty text placeholder is needed.
export const emDash = '—';

// constants for routes
export const settings = 'settings';
export const riskSettings = 'risk-settings';
export const riskSettingsBaseUri = `/${settings}/${riskSettings}`;

// constants for currency displays
export const lessThanOneCent = '< $0.01';

export const MATURE_SUPPORT_LEVEL = 'MATURE,MATURE_3RE';

export const ENABLED_USER_ACCOUNT = 'Active';
export const DISABLED_USER_ACCOUNT = 'Offboarded';

export const directionLabelMap = {
  RECEIVED: 'Received',
  SENT: 'Sent',
  ANY: 'Either',
};

export const exposureLabelMap = {
  DIRECT: 'Direct',
  INDIRECT: 'Indirect',
};

export const alertTypeLabelMap = {
  TRANSFER: 'Transfer',
  WITHDRAWAL: 'Withdrawal attempt',
  BEHAVIORAL: 'Behavioral',
};

// Behavioral alerts are not generated for users with more than this many transfers.
export const BEHAVIORAL_ALERTS_MAX_TRANSFERS = 1000;
export const BEHAVIORAL_ALERTS_DISABLED_MESSAGE =
  'Behavioral alerts will not generate for users with more than 1,000 transfers.';

// Entity Management constants
export const MAX_SCREENING_RECENCY = 1000;
export const RISK_SETTINGS_DECIMAL_PLACES = 4;
export const DEFAULT_CATEGORY_VALUE = 'No Category';
export const ENTITY_PROFILE_LITE_PARAM_NAME = 'lite';
